import { render, staticRenderFns } from "./BtnSelecionarGestorResponsavel.vue?vue&type=template&id=54f5d418"
import script from "./BtnSelecionarGestorResponsavel.vue?vue&type=script&lang=js"
export * from "./BtnSelecionarGestorResponsavel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports